export const CURRENCY_TYPE_FACTOR = {
  0: 1,
  1: 10,
  2: 100,
  3: 1,
};
